import { useAppSelector } from 'application/providers/StoreProvider';
import { selectCurrentCompanyId } from 'application/store/slices/accountSlice/selectors';

export const useAccountCompanyId = () => {
  const companyId = useAppSelector(selectCurrentCompanyId);

  return companyId;
};
